import { callApi } from './client';

export interface UserInfo {
  userId: number;
  fName: string;
  lName: string;
  fullName?: string;
  email?: string;
  legalFName?: string;
  legalLName?: string;
}

export interface LoginResult {
  authenticated: boolean;
}

export async function login(userName: string, password: string): Promise<LoginResult> {
  return callApi<LoginResult>('userApi', 'login', { userName, password });
}

export async function logout(): Promise<void> {
  await callApi('userApi', 'logout');
}

export async function getUserInfo(): Promise<UserInfo> {
  return callApi<UserInfo>('userApi', 'getUserInfo');
}

export async function sessionTimeLeft(): Promise<number> {
  return callApi<number>('userApi', 'sessionTimeLeft', { noRefreshLogin: 1 });
}

/**
 * Returns the permission-name list for the current user. Backed by
 * userApi/getMyPermissions which the backend has set to needAuth=0 so
 * any logged-in user can read their own permissions. Used to decide
 * which nav items the admin sidebar should show.
 */
export async function getMyPermissions(): Promise<string[]> {
  const r = await callApi<string[] | null>('userApi', 'getMyPermissions');
  return r ?? [];
}
